import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TextsmsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"textsms"}/>
}
